import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ExploreBrandsNavbar from "../components/ExploreBrands/ExploreBrandsNavbar";
import WellknownCollection from "../components/ExploreBrands/WellknownCollection";
// import FilterFields from "../components/ExploreBrands/FilterFields";
import ProductListing from "../components/ExploreBrands/ProductListing";
import InformationSection from "../components/ExploreBrands/InformationSection";
import FilterInput from "../components/FormComponent/FilterInput";
import SortInput from "../components/FormComponent/SortInput";

const ExploreBrands = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Replace "yourQueryParam" with the specific query parameter name you want to retrieve
  const queryValue = queryParams.get("name");

  return (
    <>
      <ExploreBrandsNavbar />
      <WellknownCollection brandName={queryValue} />
      {/* <FilterFields brandName={queryValue} /> */}

      <FilterFieldsNew />
      <ProductListing />
      {/* <InformationSection brandName={queryValue} /> */}
    </>
  );
};

export default ExploreBrands;

const FilterFieldsNew = () => {
  const [formData, setFormData] = useState({
    rating: "",
    country: "",
    city: "",
    sort: "",
  });

  const handleChangeFormData = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-2">
      <div className="flex justify-between items-center mt-4">
        <div className="flex flex-wrap lg:block md:block sm:hidden justify-center items-center gap-2">
          {/* <p className="flex jutify-center items-center gap-2 text-[18px] font-semibold text-[#0297B2]">
              {FilterMini} Filter:
            </p> */}
          <p className="lg:text-[18px] md:text-[15px] sm:text-[13px] font-semibold text-[#0297B2]">
            Filter:
          </p>
          <FilterInput
            // label={"Sort: "}
            name={"country"}
            onChange={handleChangeFormData}
            value={formData.country}
            options={["UAE", "Saudi Arabia", "Qatar", "USA", "UK"]}
            defaultDisabledValue={"Country"}
          />
          <FilterInput
            // label={"Sort: "}
            name={"city"}
            onChange={handleChangeFormData}
            value={formData.city}
            options={["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Fujairah"]}
            defaultDisabledValue={"City"}
          />
          <FilterInput
            // label={"Sort: "}
            name={"rating"}
            onChange={handleChangeFormData}
            value={formData.rating}
            options={["5 Star", "4 Star", "3 Star", "2 Star", "1 Star"]}
            defaultDisabledValue={"Rating"}
          />
        </div>
        <SortInput
          label={"Sort by: "}
          name={"sort"}
          onChange={handleChangeFormData}
          value={formData.sort}
          options={["High to Low", "Low to High"]}
          // defaultDisabledValue={"UAE"}
        />
      </div>
    </section>
  );
};
